import { useEffect, useState } from "react";

const RecordingSegmentName = () => {
  const [dotCount, setDotCount] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setDotCount(prevDotCount => (prevDotCount + 1) % 4);
    }, 500);
    return () => clearInterval(interval);
  }, []);

  const dots = '.'.repeat(dotCount);

  return <strong>Recording{dots}</strong>;
};

export default RecordingSegmentName